var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4d908f86\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Page6.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/nav3/Page6.vue
// module id = 1094
// module chunks = 1